import GATSBY_COMPILED_MDX from "/home/runner/work/Fluvial-Geomorphology/Fluvial-Geomorphology/docs/content/page/Course_Topics/module-09.mdx";
import React from 'react';
import {Box, Container, Grid, Typography} from '@mui/material';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import Banner from '../components/Banner';
import ImgCard from '../components/ImgCard';
import MDXRender from '../components/MDXRender';
import SideNav from '../components/menus/SideNav';
import AllPagesMenu from '../components/menus/allPagesMenu';
import defaultImage from '../images/card-image.jpg';
import {ParamsContext} from '../paramsContext';
import log from 'loglevel';
log.enableAll();
const PageTemplate = _ref => {
  var _site$siteMetadata, _page$tableOfContents, _page$tableOfContents2;
  let {data: {site, mdx: page, bottomMenu: childPages, sideMenu}, children, location} = _ref;
  const urlParams = new URLSearchParams(location.search);
  const noFrame = urlParams.get('render') === 'noFrame' || false;
  const siteTitle = ((_site$siteMetadata = site.siteMetadata) === null || _site$siteMetadata === void 0 ? void 0 : _site$siteMetadata.title) || `Title`;
  const pageTitle = page.frontmatter.title || null;
  const pageDescription = page.frontmatter.description || null;
  const pageHeading = page.frontmatter.banner ? React.createElement(Banner, {
    title: page.frontmatter.title,
    description: page.frontmatter.description
  }) : React.createElement(Container, {
    maxWidth: 'xl'
  }, pageTitle && React.createElement(Typography, {
    variant: "h1",
    itemProp: "headline",
    paragraph: true,
    mt: 2
  }, pageTitle), pageDescription && React.createElement(Typography, {
    variant: "body2",
    itemProp: "headline",
    paragraph: true,
    mt: 2
  }, pageDescription));
  const cardsContent = childPages.nodes.map((card, key) => {
    var _card$frontmatter$ima, _card$frontmatter$ima2;
    return React.createElement(Grid, {
      key: key,
      item: true,
      xs: 12,
      md: 6,
      lg: 3
    }, React.createElement(ImgCard, {
      img: ((_card$frontmatter$ima = card.frontmatter.image) === null || _card$frontmatter$ima === void 0 ? void 0 : (_card$frontmatter$ima2 = _card$frontmatter$ima.childImageSharp) === null || _card$frontmatter$ima2 === void 0 ? void 0 : _card$frontmatter$ima2.gatsbyImageData) || defaultImage,
      imgAlt: card.frontmatter.imageAlt,
      to: card.fields.slug,
      heading: card.frontmatter.title,
      headingVariant: "h5"
    }, React.createElement(Typography, {
      variant: "body2"
    }, card.frontmatter.blurb)));
  });
  const hasSidebar = Boolean(!noFrame);
  return React.createElement(ParamsContext.Provider, {
    value: {
      noFrame
    }
  }, React.createElement(Layout, {
    location: location,
    title: siteTitle
  }, React.createElement(Box, {
    component: "article",
    itemScope: true,
    itemType: "http://schema.org/Article",
    sx: {
      position: 'relative'
    }
  }, !page.frontmatter.isHome ? React.createElement(React.Fragment, null, React.createElement(Box, {
    component: "header"
  }, pageHeading), React.createElement(Container, {
    maxWidth: 'xl'
  }, React.createElement(Grid, {
    container: true,
    spacing: 14
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    md: hasSidebar ? 8 : 12
  }, React.createElement(MDXRender, null, children)), hasSidebar && React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4,
    component: "aside"
  }, ((_page$tableOfContents = page.tableOfContents) === null || _page$tableOfContents === void 0 ? void 0 : (_page$tableOfContents2 = _page$tableOfContents.items) === null || _page$tableOfContents2 === void 0 ? void 0 : _page$tableOfContents2.length) > 0 && React.createElement(SideNav, {
    heading: "On this page",
    headingType: "h2",
    content: page.tableOfContents,
    showHeading: true
  }), React.createElement(AllPagesMenu, {
    heading: "All pages",
    headingType: "h2",
    nodes: sideMenu.nodes,
    showHeading: true
  })))), React.createElement(Container, {
    maxWidth: "xl",
    sx: {
      mb: 4
    }
  }, React.createElement(Grid, {
    container: true,
    spacing: 4,
    sx: {
      my: 3
    }
  }, cardsContent))) : React.createElement(MDXRender, null, children))));
};
export const Head = _ref2 => {
  let {data: {mdx: page}} = _ref2;
  return React.createElement(Seo, {
    title: page.frontmatter.title,
    description: page.frontmatter.description
  });
};
PageTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PageTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
const pageQuery = "1353385144";
